
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20.349 19.006"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M.587 4.871L10.115.515a.149.149 0 01.122 0l9.528 4.356a.147.147 0 01.006.264l-9.528 4.894a.147.147 0 01-.134 0L.581 5.135a.147.147 0 01.006-.264z"}}),_c('path',{attrs:{"d":"M15.771 7.502l3.992 1.825a.147.147 0 01.006.264l-9.528 4.894a.147.147 0 01-.134 0L.579 9.591a.147.147 0 01.006-.264l3.846-1.758"}}),_c('path',{attrs:{"d":"M15.771 11.501l3.992 1.825a.147.147 0 01.006.264l-9.528 4.894a.147.147 0 01-.134 0L.579 13.59a.147.147 0 01.006-.264l3.846-1.758"}})])])
          )
        }
      }
    